export const defaultIconSize = 8
export const defaultIconSpace = 4
